// Lazy eruda on ?debug (IMPLEMENTATION §6.2): in-page devtools for iOS without a Mac. Separate chunk.
export async function loadEruda(): Promise<void> {
  const mod = await import('eruda');
  mod.default.init();
}
